import { useAuth0 } from "@auth0/auth0-react";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import { ReactComponent as Reminder } from "assets/icons/reminder.svg";
import { ReactComponent as YahSuccess } from "assets/icons/yah_success.svg";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import "./Success.scss";

const Success = ({ values }) => {
  const { selectedDeceased } = useSelector((state) => state.CommonStates);
  const { getAccessTokenSilently } = useAuth0();
  let selectedMourners = [];
  const mourners = selectedDeceased?.map((dec) => {
    return dec?.mourners_list?.forEach((item) => {
      selectedMourners.push({
        ...item,
        date_of_death: dec?.date_of_death,
        deceased_name: dec?.name,
      });
      return item;
    });
  });
  const mournerWithEmail = selectedMourners?.filter(
    (item) => item?.member_id?.email_address
  );
  const mournersWithoutEmail = selectedMourners?.filter(
    (item) => !item?.member_id?.email_address
  );

  const sendEmail = async () => {
    const token = await getAccessTokenSilently();

    const recievers = values?.recipients?.map((item) => {
      return {
        deceasedId: item?.deceasedId,
        memberIds: item?.member_id?._id ? [item?.member_id?._id] : undefined,
        nonMember:
          !item?.member_id?._id && item?.email ? [item?.email] : undefined,
      };
    });

    const data = {
      deceased: recievers,
      templateId: values?.template_id,
    };
    try {
      const response = await FinancialSetting.sendEmailToMourner(token, data);
      toastr.success("success", "Yahrzeit Letter Successfully Sent");
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
    }
  };

  useEffect(() => {
    if (values?.recipients?.length > 0) {
      sendEmail();
    }
  }, []);

  return (
    <div className="success_container">
      <div className="success_header">
        <div className="success_icon">
          <YahSuccess />
        </div>
        <h3>Yahrzeit Letter Successfully Sent</h3>
        <p>
          The total number of recipients is{" "}
          {values?.mournerWithEmail?.length}
        </p>
      </div>
      <hr className="my-5" />
      <div className="success_summary">
        <h3>Summary:</h3>
        <ul>
          <li>
            {values?.recipients?.length} observers received the letter virtually
          </li>
          <li>
            {values?.printed?.length} observers will receive the letter by post
          </li>
        </ul>
        <div className="reminder">
          <Reminder />
          Do not forget to post the letters.
          {/* <span className="remind_me">Remind Me</span> */}
        </div>
      </div>
    </div>
  );
};

export default Success;
